export const REPORT_STATUS_COLOR: Record<string, string> = {
  pending: "#45BE77",
  cancel: "#FB3B3B",
};

export const PRODUCT_TYPE_COLOR: Record<string, string> = {
  invoice: "#5C69E8",
  cashsale: "#45BE77",
};

export const REPORT_STATUS_LABEL: Record<string, string> = {
  pending: "ปกติ",
  cancel: "ยกเลิก",
};

export const PRODUCT_TYPE_LABEL: Record<string, string> = {
  invoice: "เครดิต",
  cashsale: "ขายสด",
};
